export const colors = {
  green: '#3a6a4a',
};
